import { useState, useEffect, memo, useCallback } from "react";
import AnimacionCarga from "../components/animacion_de_carga";
import TablaGenerica from "../components/tablas";
import { obtenerNovedades } from "../../functions/consultas";
import BotonSOS from "./sos/boton_sos";
import { crearRegistro } from "../../functions/crud";
import {
  TIPOS_NOVEDAD, CAMPOS_VEHICULO, SITIOS_VEHICULO, fechaNovedad, fotosNovedad, nuevaNovedad, rutaNovedades, descargarPlantillaNovedades,
} from "../../functions/importar_novedades";
import { asistenteCargarNovedades, menuAccionesNovedad, menuArchivosNovedades, resumenNovedad } from "./dialogos_novedades";
import { BotonArchivos, abrirMenuArchivos, botonOpciones, eliminarConConfirmacion, mostrarFotos } from "./listado_comun";
import { fechaHoraDart, formatearFechaListado } from "../../functions/pase_visitante";
import { subirArchivoFirebase } from "../../functions/archivos_firebase";
import Swal from "sweetalert2";
import "bootstrap-icons/font/bootstrap-icons.css";

const COLUMNAS = [
  { label: "Fecha",                key: "fechayhora" },
  { label: "Cliente",              key: "razonSocial" },
  { label: "Usuario",              key: "usuario" },
  { label: "Tipo de novedad",      key: "tipoZona" },
  { label: "Descripción",          key: "descripcion_novedad" },
  { label: "Placa",                key: "placa" },
];


const SITIOS_VIVIENDA = ["VIVIENDA","NOTIFICACIÓN","CONVIVENCIA","ADMINISTRACIÓN"];

const selectOptions = (lista, seleccionado = lista[0]) =>
  lista.map(o => `<option value="${o}" ${o === seleccionado ? "selected" : ""}>${o}</option>`).join("");

const vehiculoHtml = () =>
  CAMPOS_VEHICULO.map(({ key, label }) => `
    <div style="display:flex;flex-direction:column;gap:4px;">
      <label style="font-size:12px;font-weight:600;color:#555;text-transform:uppercase;">${label}</label>
      <select id="${key}" style="${estiloSelect}">
        <option value="BUENO">BUENO</option>
        <option value="MALO">MALO</option>
      </select>
    </div>
  `).join("");

const estiloInput  = "width:100%;padding:9px 12px;border:1.5px solid #ddd;border-radius:8px;font-size:14px;box-sizing:border-box;outline:none;";
const estiloSelect = "width:100%;padding:9px 12px;border:1.5px solid #ddd;border-radius:8px;font-size:14px;box-sizing:border-box;background:#fff;";
const estiloLabel  = "display:block;margin-bottom:5px;font-size:12px;font-weight:600;color:#555;text-transform:uppercase;letter-spacing:0.4px;";

const ListadoNovedades = memo(() => {
  const [datos,    setDatos]    = useState([]);
  const [cargando, setCargando] = useState(true);

  const capturarDatos = useCallback(async () => {
    try {
      const data = await obtenerNovedades();
      setDatos(data.map(item => {
        return { ...item, fechayhora: formatearFechaListado(fechaNovedad(item)), fotos: fotosNovedad(item) };
      }));
    } catch (error) {
      console.error("Error al obtener novedades:", error);
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => { capturarDatos(); }, [capturarDatos]);

  const crearNovedad = useCallback(async () => {
    const nit = localStorage.getItem("CodigoCliente") || "";

    const { value: paso1 } = await Swal.fire({
      title: "Nueva Novedad",
      html: `
        <div style="text-align:left;padding:0 8px;">

          <div style="margin-bottom:16px;">
            <label style="${estiloLabel}">Tipo de novedad</label>
            <select id="tipoZona" style="${estiloSelect}">
              ${selectOptions(TIPOS_NOVEDAD)}
            </select>
          </div>

          <div id="seccionVivienda" style="display:block;">

            <div style="margin-bottom:12px;">
              <label style="${estiloLabel}">Tipo de dirección</label>
              <select id="tipoDireccion" style="${estiloSelect}">
                <option value="">Selecciona</option>
                <option value="apartamento">Apartamento</option>
                <option value="casa">Casa</option>
                <option value="administracion">Administración</option>
                <option value="porteria">Portería</option>
                <option value="otro">Otro</option>
              </select>
            </div>

            <div id="inputsTorre" style="display:none;margin-bottom:12px;">
              <div style="display:flex;gap:12px;">
                <div style="flex:1;">
                  <label style="${estiloLabel}">Torre / Etapa</label>
                  <input id="numeroTorre" placeholder="Número" style="${estiloInput}" />
                </div>
                <div style="flex:1;">
                  <label style="${estiloLabel}">Apartamento</label>
                  <input id="numeroApartamento" placeholder="Número" style="${estiloInput}" />
                </div>
              </div>
            </div>

            <div id="inputsCasa" style="display:none;margin-bottom:12px;">
              <div style="display:flex;gap:12px;">
                <div style="flex:1;">
                  <label style="${estiloLabel}">Manzana</label>
                  <input id="manzana" placeholder="Número" style="${estiloInput}" />
                </div>
                <div style="flex:1;">
                  <label style="${estiloLabel}">Casa</label>
                  <input id="numeroCasa" placeholder="Número" style="${estiloInput}" />
                </div>
              </div>
            </div>

            <div id="inputOtro" style="display:none;margin-bottom:12px;">
              <label style="${estiloLabel}">Dirección</label>
              <input id="direccionOtra" placeholder="Escribe la dirección" style="${estiloInput}" />
            </div>

          </div>

          <div id="seccionPlaca" style="margin-bottom:16px;display:none;">
            <label style="${estiloLabel}">Placa del vehículo</label>
            <input id="placa" placeholder="Ej: ABC123" style="${estiloInput}" />
          </div>

          <div style="margin-bottom:16px;">
            <label style="${estiloLabel}">Descripción <span style="color:#e53935">*</span></label>
            <textarea id="descripcion" placeholder="Describa la novedad..."
              style="${estiloInput}min-height:100px;resize:vertical;"></textarea>
          </div>

        </div>
      `,
      didOpen: () => {
        const tipoZona        = document.getElementById("tipoZona");
        const seccionVivienda = document.getElementById("seccionVivienda");
        const seccionPlaca    = document.getElementById("seccionPlaca");
        const tipoDireccion   = document.getElementById("tipoDireccion");
        const inputsTorre     = document.getElementById("inputsTorre");
        const inputsCasa      = document.getElementById("inputsCasa");
        const inputOtro       = document.getElementById("inputOtro");

        const actualizarSeccion = () => {
          const val = tipoZona.value;
          seccionVivienda.style.display = SITIOS_VIVIENDA.includes(val) ? "block" : "none";
          seccionPlaca.style.display    = SITIOS_VEHICULO.includes(val) ? "block" : "none";
        };

        const actualizarDireccion = () => {
          const val = tipoDireccion.value;
          inputsTorre.style.display = val === "apartamento" ? "block" : "none";
          inputsCasa.style.display  = val === "casa"        ? "block" : "none";
          inputOtro.style.display   = val === "otro"        ? "block" : "none";
        };

        tipoZona.addEventListener("change", actualizarSeccion);
        tipoDireccion.addEventListener("change", actualizarDireccion);
        actualizarSeccion();
      },
      showCancelButton:  true,
      confirmButtonText: "Siguiente →",
      cancelButtonText:  "Cancelar",
      width: 580,
      preConfirm: () => {
        const tipoZona    = document.getElementById("tipoZona").value;
        const descripcion = document.getElementById("descripcion").value.trim();
        const placa       = document.getElementById("placa")?.value.trim() || "";

        if (!descripcion) {
          Swal.showValidationMessage("La descripción es obligatoria");
          return false;
        }

        let direccion = "";
        if (SITIOS_VIVIENDA.includes(tipoZona)) {
          const tipoDireccion = document.getElementById("tipoDireccion").value;

          if (tipoDireccion === "apartamento") {
            const torre = document.getElementById("numeroTorre").value.trim();
            const apto  = document.getElementById("numeroApartamento").value.trim();
            if (!torre || !apto) {
              Swal.showValidationMessage("Completa torre y número de apartamento");
              return false;
            }
            direccion = `TORRE ${torre} APARTAMENTO ${apto}`;

          } else if (tipoDireccion === "casa") {
            const manzana = document.getElementById("manzana").value.trim();
            const casa    = document.getElementById("numeroCasa").value.trim();
            if (!manzana || !casa) {
              Swal.showValidationMessage("Completa manzana y número de casa");
              return false;
            }
            direccion = `MANZANA ${manzana} CASA ${casa}`;

          } else if (tipoDireccion === "administracion") {
            direccion = "ADMINISTRACIÓN";

          } else if (tipoDireccion === "porteria") {
            direccion = "PORTERÍA";

          } else if (tipoDireccion === "otro") {
            const otra = document.getElementById("direccionOtra").value.trim();
            if (!otra) {
              Swal.showValidationMessage("Escribe la dirección");
              return false;
            }
            direccion = otra;

          } else {
            Swal.showValidationMessage("Selecciona el tipo de dirección");
            return false;
          }
        }

        return { tipoZona, descripcion, direccion, placa };
      },
    });

    if (!paso1) return;

    let estadoVehiculo = {};
    if (SITIOS_VEHICULO.includes(paso1.tipoZona)) {
      const { value: paso2 } = await Swal.fire({
        title: "Estado del vehículo",
        html: `
          <div style="text-align:left;padding:0 8px;">
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
              ${vehiculoHtml()}
            </div>
          </div>
        `,
        showCancelButton:  true,
        confirmButtonText: "Siguiente →",
        cancelButtonText:  "← Atrás",
        width: 560,
        preConfirm: () =>
          Object.fromEntries(
            CAMPOS_VEHICULO.map(({ key }) => [
              key, document.getElementById(key)?.value || "BUENO"
            ])
          ),
      });

      if (!paso2) return;
      estadoVehiculo = paso2;
    }

    const { value: paso3 } = await Swal.fire({
      title: "Agregar Fotos",
      html: `
        <div style="text-align:left;padding:0 8px;">
          <label style="${estiloLabel}">Fotos (máximo 6)</label>
          <input id="fotos" type="file" accept="image/*" multiple
            style="${estiloInput}padding:8px;cursor:pointer;" />
          <div id="previewFotos"
            style="display:flex;flex-wrap:wrap;gap:8px;margin-top:14px;min-height:40px;"></div>
          <p style="margin-top:10px;font-size:12px;color:#888;">Las fotos son opcionales.</p>
        </div>
      `,
      didOpen: () => {
        const input   = document.getElementById("fotos");
        const preview = document.getElementById("previewFotos");

        input.addEventListener("change", () => {
          preview.innerHTML = "";
          const archivos = Array.from(input.files).slice(0, 6);
          archivos.forEach(file => {
            const url = URL.createObjectURL(file);
            preview.innerHTML += `
              <img src="${url}" style="width:80px;height:80px;object-fit:cover;
                border-radius:8px;border:2px solid #e0ddf8;" />
            `;
          });
        });
      },
      showCancelButton:  true,
      confirmButtonText: "Guardar novedad",
      cancelButtonText:  "← Atrás",
      width: 560,
      preConfirm: () => {
        const files = document.getElementById("fotos").files;
        return { fotos: Array.from(files).slice(0, 6) };
      },
    });

    if (!paso3) return;

    Swal.fire({
      title: "Guardando novedad…",
      text: paso3.fotos.length > 0 ? "Subiendo fotos, por favor espere." : "Por favor espere.",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const ahora = new Date();
      const fotos = [];
      for (let i = 0; i < paso3.fotos.length; i++) {
        const file = paso3.fotos[i];
        const ext  = file.name.split(".").pop() || "jpg";
        fotos.push(await subirArchivoFirebase(`novedades/${nit}/${fechaHoraDart(ahora)}_foto_${i}.${ext}`, file));
      }

      await crearRegistro(rutaNovedades(nit, ahora), nuevaNovedad({
        fecha: ahora,
        tipo: paso1.tipoZona,
        descripcion: paso1.descripcion,
        direccion: paso1.direccion,
        placa: paso1.placa,
        fotos,
        vehiculo: estadoVehiculo,
      }));

      Swal.fire({
        title: "¡Novedad creada!",
        text: "La novedad fue registrada exitosamente.",
        icon: "success",
        timer: 2200,
        showConfirmButton: false,
      });

      capturarDatos();
    } catch (error) {
      console.error("Error al crear novedad:", error);
      Swal.fire("Error", "No se pudo guardar la novedad: " + error.message, "error");
    }
  }, [capturarDatos]);

  const abrirArchivos = useCallback(async () => {
    const guardo = await abrirMenuArchivos({
      menu: menuArchivosNovedades,
      columnas: COLUMNAS,
      filas: datos,
      archivoCsv: "listado_novedades.csv",
      descargarPlantilla: descargarPlantillaNovedades,
      cargar: asistenteCargarNovedades,
    });
    if (guardo) await capturarDatos();
  }, [datos, capturarDatos]);

  // Un solo botón por fila; las acciones se eligen en una ventana como la de archivos.
  const abrirAcciones = async (fila) => {
    const opcion = await menuAccionesNovedad({ novedad: fila, cantidadFotos: fila.fotos.length });
    if (opcion === "resumen") resumenNovedad(fila);
    if (opcion === "fotos") mostrarFotos("Fotos de la novedad", fila.fotos, "Esta novedad no tiene fotos");
    if (opcion === "eliminar" && await eliminarConConfirmacion({
      fila, singular: "esta novedad", descripcion: `${fila.tipoZona || "Novedad"} · ${fila.fechayhora || ""}`,
    })) await capturarDatos();
  };

  if (cargando) return <AnimacionCarga />;

  return (
    <>
      <TablaGenerica
        datos={datos}
        titulos={COLUMNAS.map(c => c.label.toUpperCase())}
        campos={COLUMNAS.map(c => c.key)}
        elementosPorPagina={3000}
        columnaOrdenInicial={0}
        direccionOrdenInicial="desc"
        botones={botonOpciones(abrirAcciones)}
        tituloBotones="ACCIONES"
        contenidoExtra={
          <>
            <button onClick={capturarDatos} title="Refrescar"><i className="bi bi-arrow-clockwise" /></button>
            <BotonArchivos onClick={abrirArchivos} />
            <button onClick={crearNovedad} title="Nueva Novedad"><i className="bi bi-plus-lg" /></button>
          </>
        }
      />

      <BotonSOS />
    </>
  );
});

export default ListadoNovedades;